import { render } from "./index.vue?vue&type=template&id=d00db20e&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=d00db20e&scoped=true&lang=less"

import exportComponent from "D:\\code\\hyz-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d00db20e"]])

export default __exports__